import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export default function CountdownTimer({
  start,
}) {
  const [prevCount, setPrevCount] = useState(start);

  useEffect(() => {
    setPrevCount(start); 
  }, [start]);

  return (
    <div className="relative h-24 w-24 overflow-hidden bg-gray-800 rounded-lg text-white flex items-center justify-center">
      <AnimatePresence mode="popLayout">
        <motion.div
          key={prevCount}
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 50, opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
          className="absolute text-6xl font-bold"
        >
          {prevCount}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
